/**
 * @generated SignedSource<<f86445fafff1d7fa5f260325e5891021>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type user_isGuest$data = {
  readonly guest: boolean;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentType": "user_isGuest";
};
export type user_isGuest$key = {
  readonly " $data"?: user_isGuest$data;
  readonly " $fragmentSpreads": FragmentRefs<"user_isGuest">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "user_isGuest"
};

(node as any).hash = "449015e5ec0df2a6f22211a2ce9db151";

export default node;
